module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cmsdetail"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('div', {
    staticClass: "container_left_title"
  }, [_vm._v("\n          " + _vm._s(_vm.row.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "container_left_tips"
  }, [_c('div', {
    staticClass: "tips_left"
  }, [(_vm.breadData.name) ? _c('div', {
    staticClass: "tips_left_tag"
  }, [_vm._v(_vm._s(_vm.breadData.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "operations_common operations_date"
  }, [_c('div', {
    staticClass: "operations_common_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "operations_common_num"
  }, [_vm._v("\n                " + _vm._s(_vm._f("yearForm")(_vm.row.update_time)) + "年" + _vm._s(_vm._f("monthForm")(_vm.row.update_time)) + "月" + _vm._s(_vm._f("dayForm")(_vm.row.update_time)) + "日\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "operations_common operations_hotnum"
  }, [_c('div', {
    staticClass: "operations_common_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "operations_common_num"
  }, [_vm._v("\n                " + _vm._s(_vm.row.views_count) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tips_right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content"
  }, [(_vm.row.files.length > 0) ? _c('div', {
    staticClass: "fdown"
  }, [_vm._v("\n            文件下载\n            "), _vm._l((_vm.row.files), function(file, key) {
    return _c('p', {
      key: key,
      on: {
        "click": function($event) {
          return _vm.download(file)
        }
      }
    }, [_vm._v(_vm._s(file.name))])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_left_text",
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  })])]), _vm._v(" "), _c('RightNav', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42735530","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/CmsDetail.vue
// module id = 1395
// module chunks = 0